import type { ComputerViewModel, PersonalDataItemViewModel } from '@trinnvis/dabih-api-client';
import type { InfosecStorageUnit } from '../../pages/computers-page/infosec-procedure/infosecStorageUnit';
import type { InfosecDataItem } from '../../pages/computers-page/infosec-procedure/infosecDataItem';
import { assertIsDefined } from '../../assertIsDefined';
import type { InfosecStorageUnitTypes } from '../../pages/computers-page/infosec-procedure/infosecStorageUnitTypes';

import { dataItemName } from './data-item-name';

export const mappedDataItems = (
  personalDataItems: PersonalDataItemViewModel[],
  computers: ComputerViewModel[],
  computers2: InfosecStorageUnit[],
  assets: {
    uuid: string;
    name: string;
    number: string;
  }[],
  locations: InfosecStorageUnit[],
): InfosecDataItem[] =>
  personalDataItems
    .filter((dataItem) => {
      return !dataItem.deleted;
    })
    .filter(
      (dataItem) => dataItem.type && dataItem.type.split('.').length === 2 && dataItem.type !== 'undefined.undefined',
    )
    .map((dataItem) => {
      const type = dataItem.type;
      assertIsDefined(type);
      const [dataType, category] = type.split('.');
      let storageUnitType: InfosecStorageUnitTypes = '';
      if (dataItem.storageUnit) {
        const storageUnits = computers.filter((c) => {
          return c.uuid === dataItem.storageUnit;
        });
        if (storageUnits.length) {
          if (storageUnits[0].unitType === 'cloudService') {
            storageUnitType = 'cloudServices';
          }
          if (storageUnits[0].unitType === 'remoteServer') {
            storageUnitType = 'remoteServers';
          }
          if (storageUnits[0].unitType === 'computer') {
            storageUnitType = 'computers';
          }
        }
      }

      const result: InfosecDataItem = {
        uuid: dataItem.uuid,
        name: dataItem.name ?? dataItemName(dataItem, computers2, assets, locations) ?? '',
        application: dataItem.application ?? '',
        dataType: dataType,
        category: category,
        personalData: false,
        dataProcessor: dataItem.dataProcessor ?? '',
        accessingEmployees: dataItem.accessingEmployees ?? [],
        accessingPartners: dataItem.accessingPartners ?? [],
        assets: dataItem.relatedAssets ?? [],
        storageUnit: dataItem.storageUnit ?? '',
        storageLocation: dataItem.storageLocation ?? '',
        storageUnitType: storageUnitType,
        backupFrequency: dataItem.backupFrequency ?? '',
        backupResponsible: dataItem.backupResponsible ?? '',
        noBackupReason: dataItem.noBackupReason ?? '',
        createdDateTime: dataItem.createdDateTime ?? '',
      };
      return result;
    });
